import React, { ReactElement, useState, useEffect } from 'react';
import {
  afterSaleConfirmRepair,
  getAfterSaleProgress
} from '../../../../api/filling-pile';
import { getLoginInfoPromise } from '../../../../utils/common';
import { useLocation, useHistory } from 'react-router-dom';
import { formateDatePile, getPlatform } from '../../../../utils/common';
import './index.less';
import 'react-photo-view/dist/react-photo-view.css';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import Toast from '../../../../components/toast';
import FullLoading from '../../../../components/full-loading';
import { resolveImageUrl } from '../../../../utils/oss_tools';

export default function MaintenanceResults(): ReactElement {
  const [serviceInfo, setServiceInfo] = useState<any>();
  const [userInfo, setUserInfo] = useState<any>();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [resolvedPicUrls, setResolvedPicUrls] = useState<string[]>([]);
  const loc = useLocation();
  const router = useHistory();
  const orderNo: any = new URLSearchParams(loc.search).get('orderNo');
  const setTitle = () => {
    document.title = '维修结果';
  };
  const confirmRes = () => {
    if (isSubmitting) {
      return;
    }
    setIsSubmitting(true);
    FullLoading.show({
      text: '确认中'
    });
    let newArr = [];
    if (serviceInfo && serviceInfo.selfFeeItem) {
      newArr = serviceInfo.selfFeeItem.map(item => {
        return { ...item, id: item.selfFeeProjectId };
      });
    }
    console.log('newarr', newArr);
    const param = {
      repairSelfFeeProject: newArr,
      repairFee: serviceInfo.repairFee,
      operateType: 'user'
    };
    afterSaleConfirmRepair({
      uid: userInfo.uid.toString(),
      name: userInfo.name,
      orderNo: orderNo,
      param
    })
      .then(res => {
        console.log(res);
        FullLoading.hide();
        Toast.show({
          text: '已确认维修结果',
          duration: 2000
        });
        router.goBack();
      })
      .catch(err => {
        FullLoading.hide();
        setIsSubmitting(false);
        console.log('err', err);
        Toast.show({
          text: err && err.message,
          duration: 2000
        });
      });
  };
  useEffect(() => {
    FullLoading.show({
      text: '加载中'
    });
    const phoneModel = getPlatform();
    getLoginInfoPromise()
      .then(res => {
        let name: string = res.username;
        if (phoneModel === 'android') {
          name = res.nickname;
        }
        setUserInfo({
          uid: res.uid,
          name: name
        });
        getAfterSaleProgress({
          uid: res.uid,
          name: name,
          orderNo: orderNo
        }).then(info => {
          console.log('par-huhh-afterSale',info);
          setServiceInfo(info && info.data);
          // 维修照片走加密适配器（install=0 售后工单）
          if (info?.data?.pictures) {
            Promise.all(
              info.data.pictures.map((pic: any) =>
                resolveImageUrl(pic)
              )
            ).then(urls => setResolvedPicUrls(urls));
          }
          FullLoading.hide();
        });
      })
      .catch(err => {
        console.log('err', err);
        FullLoading.hide();
      });
    setTitle();
  }, []);
  return (
    <div className="report">
      <div className="info">
        <div className="info-title">维修信息</div>
        <div className="install-time">
          <div className="text">维修时间</div>
          <div className="date">
            {serviceInfo &&
              formateDatePile(serviceInfo.repairTime).split(' ')[0]}
          </div>
        </div>
        <div className="install-fee">
          <div className="text">维修费用</div>
          <div className="num">{serviceInfo && serviceInfo.repairFee}元</div>
        </div>
        <div className="tips-text">
          确认维修结果表示您认可服务商的维修质量，并对维修费用没有异议。
        </div>
        <div className="photo">现场照片</div>
        <PhotoProvider>
          <div className="photo-item">
            {serviceInfo &&
              serviceInfo.pictures.map((path, index) => (
                <PhotoView src={resolvedPicUrls[index] || path.ossUrl} key={index}>
                  <img src={resolvedPicUrls[index] || path.ossUrl} alt="" />
                </PhotoView>
              ))}
          </div>
        </PhotoProvider>
        <div className="auto-confirm">
          {
            serviceInfo && serviceInfo.operateType === 1 ?
              <p>提示:超时未确认,系统已自动确认</p> : ""
          }
        </div>
      </div>
      <div className="btn">
        {serviceInfo && serviceInfo.orderStatus === 4 ? (
          <button
            className="report-btn"
            onClick={confirmRes}
            disabled={isSubmitting}
          >
            {isSubmitting ? '确认中...' : '确认维修结果'}
          </button>
        ) : (
          ''
        )}
      </div>
    </div>
  );
}
